import { apiRequestActions } from '@ackee/redux-utils';
import { downloadDocumentsTypes } from './types';

export default apiRequestActions(downloadDocumentsTypes);
